import { useAuth0 } from "@auth0/auth0-react";
import { useCallback } from "react";

import { EnvVar } from "@/env";
import { queryClient } from "@/lib/react-query";

export const useLogout = () => {
  const { logout: auth0Logout } = useAuth0();
  const logout = useCallback(async () => {
    localStorage.clear();
    sessionStorage.clear();
    queryClient.removeQueries();

    auth0Logout({
      logoutParams: { returnTo: window.location.origin },
      clientId: EnvVar.auth0ClientId,
    });
  }, [auth0Logout]);

  return {
    logout,
  };
};
